import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useServices } from '../../hooks/useServices';
import { exportAllData } from '../../lib/exportFile';
import styles from './Welcome.module.css';

/** Tells a visitor with records already on this device that signing in uploads them, and offers a backup first. */
export function LocalDataNotice({ count }: { readonly count: number }) {
  const { t } = useTranslation();
  const { store, now } = useServices();
  const [message, setMessage] = useState<{ readonly text: string; readonly failed: boolean } | null>(null);

  const exportNow = (): void => {
    exportAllData(store, now()).then(
      ({ filename }) => setMessage({ text: t('welcome.localData.exported', { name: filename }), failed: false }),
      (error: unknown) => {
        console.error('export before sign-in failed', error);
        setMessage({ text: t('stats.export.failed'), failed: true });
      },
    );
  };

  return (
    <div className={styles.notice} role="note" data-testid="welcome-local-data">
      <p>{t('welcome.localData.text', { count })}</p>
      <button type="button" className={styles.linkButton} onClick={exportNow} data-testid="welcome-export">
        {t('welcome.localData.export')}
      </button>
      {message === null ? null : (
        <p className={message.failed ? styles.error : undefined} role="status" data-testid="welcome-export-result">
          {message.text}
        </p>
      )}
    </div>
  );
}
